//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VideoWrapper from '@/components/VideoWrapper.vue';
import MiniNavBar from '@/components/MiniNavBar.vue';
export default {
    components: { MiniNavBar, VideoWrapper },
    beforeRouteEnter(to, from, next) {
        const id = to.query.id;
        next(vm => {
            vm.getGuideDetail(id);
        });
    },
    data() {
        return {
            data: ''
        };
    },
    methods: {
        getGuideDetail(id) {
            this.axios({
                method: 'post',
                url: '/article/detail',
                data: {
                    id
                }
            }).then(res => {
                if (res.code === 0) {
                    this.data = res.data;
                }
            });
        }
    }
};
